/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { RouteRecordRaw } from "vue-router";
import BotSidebar from "../views/bot/Sidebar.vue";
import BotTopnav from "../views/bot/Topnav.vue";
const prefix = "/bot/:chatbotId";

export const BotRoutes = [
  {
    path: prefix,
    redirect: {
      name: "BotDashboard"
    }
  },
  {
    path: prefix + "/dashboard",
    name: "BotDashboard",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Dashboard.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
  },
  {
    path: prefix + "/versions",
    name: "BotVersions",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Versions.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
  },
  {
    path: prefix + "/flows",
    name: "BotFlows",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Flows.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
  }, {
    path: prefix + "/flow/:flowId",
    name: "BotFlow",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Flow.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
  }, {
    path: prefix + "/files",
    name: "BotFiles",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Files.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
  }, {
    path: prefix + "/training",
    name: "BotTraining",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Training.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
    children: [{
      name: "BotTrainingModels",
      path: "",
      component: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/TrainingModels.vue"),
    }, {
      name: "BotTrainingTrainingsData",
      path: "languages",
      component: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/TrainingTrainingsData.vue"),
    }]
  }, {
    path: prefix + "/faqs",
    name: "BotFaqs",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Faqs.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
  }, {
    path: prefix + "/faqs/:faqId",
    name: "BotFaq",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Faq.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
  }, {
    path: prefix + "/channels",
    name: "BotChannels",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Channels.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
  }, {
    path: prefix + "/settings",
    name: "Settings",
    components: {
      default: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/Settings.vue"),
      sidenav: BotSidebar,
      topnav: BotTopnav
    },
    children: [{
      name: "BotSettingsBehavior",
      path: "",
      component: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/SettingsBehavior.vue"),
    }, {
      name: "BotSettingsLanguages",
      path: "languages",
      component: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/SettingsLanguages.vue"),
    }, {
      name: "BotSettingsPublicProfiles",
      path: "public-profiles",
      component: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/SettingsPublicProfiles.vue"),
    }, {
      name: "BotSettingsInbox",
      path: "inbox",
      component: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/SettingsInbox.vue"),
    }, {
      name: "BotSettingsAPI",
      path: "api",
      component: () => import(/* webpackChunkName: "chatbot" */ "../views/bot/SettingsAPI.vue"),
    }]
  },
] as RouteRecordRaw[];